//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ContentHeader from 'components/ContentHeader'
import Vue from 'vue'

export default {
  components: {
    ContentHeader
  },
  data () {
    return {
      password: '',
      newPassword: '',
      comfirmPassword: ''
    }
  },
  created () {
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    savePassword: function () {
      let $this = this
      if (!this.password) {
        $this.alert('旧密码不能为空', 2);
        return false;
      }
      if (!this.newPassword) {
        $this.alert('新密码不能为空', 2);
        return false;
      }
      if (!this.comfirmPassword) {
        $this.alert('请确认新密码', 2);
        return false;
      }
      var params = {
        password: this.password,
        new_password: this.newPassword,
        confirm_password: this.comfirmPassword
      }
      Vue.http({
        method: 'PUT',
        url: this.serviceUrl('api/user/password'),
        data: params
      }).then((resp) => {
        if (resp.data.errcode === 0) {
          $this.alert('保存成功', 1);
          $this.password = '';
          $this.newPassword = '';
          $this.comfirmPassword = '';
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/PageUserPassword.vue